import { useEffect, useState } from 'react'
import PdfPageEnd from '../PdfPageEnd/PdfPageEnd'
import PdfPageHeatMap from '../PdfPageHeatMap/PdfPageHeatMap'
import PdfPageHeatMapFrame from '../PdfPageHeatMapFrame/PdfPageHeatMapFrame'
import { isPortraitByProjectInfo } from '@/helpers/productCategory'

const PORTRAIT_HEATMAPS_PER_PAGE = 12
const DEFAULT_HEATMAPS_PER_PAGE = 9

interface Props {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  baseNo: number
}
function HeatMapPdfPage(props: Props) {
  const heatMapsPerPage = isPortraitByProjectInfo(props.project)
    ? PORTRAIT_HEATMAPS_PER_PAGE
    : DEFAULT_HEATMAPS_PER_PAGE
  const heatMaps = props.project.detailMetrics.map((detail) => {
    return { heatMap: detail.heatMap, second: detail.secondCount }
  })
  const framePages = heatMaps.reduce(
    (prev: { heatMap: string; second: number }[][], cur) => {
      const last = prev[prev.length - 1]
      if (!last) {
        return [[cur]]
      } else {
        if (last.length < heatMapsPerPage) {
          last.push(cur)
        } else {
          prev.push([cur])
        }
      }
      return prev
    },
    [] as { heatMap: string; second: number }[][]
  )
  const [renderedCnt, setRenderedCnt] = useState(0)

  useEffect(() => {
    props.onRendered(renderedCnt)
  }, [renderedCnt])

  return (
    <>
      <PdfPageHeatMap
        no={props.baseNo + 1}
        project={props.project}
        onRendered={(cnt) => {
          setRenderedCnt((prev) => prev + cnt)
        }}
      />
      {framePages.map((frames, index) => {
        return (
          <PdfPageHeatMapFrame
            key={index}
            no={props.baseNo + 2 + index}
            project={props.project}
            heatMaps={frames}
            onRendered={(cnt) => {
              setRenderedCnt((prev) => prev + cnt)
            }}
          />
        )
      })}
      <PdfPageEnd
        no={props.baseNo + 2 + framePages.length}
        project={props.project}
        onRendered={(cnt) => {
          setRenderedCnt((prev) => prev + cnt)
        }}
      />
    </>
  )
}

export default HeatMapPdfPage
